function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var PlayerPlugin =
/*#__PURE__*/
function () {
  function PlayerPlugin() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PlayerPlugin);

    this._config = config;
  }

  _createClass(PlayerPlugin, [{
    key: "beforeVideo",
    value: function beforeVideo() {}
  }, {
    key: "afterVideo",
    value: function afterVideo() {}
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);

  return PlayerPlugin;
}();

var VendorPlugin =
/*#__PURE__*/
function () {
  function VendorPlugin() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, VendorPlugin);

    _defineProperty(this, "isVendor", true);

    this._src = '';
    this._loaded = false;
    this._loading = false;
    this._initialized = false;
    this._concurrent = true;
    this._autoLoad = true;
    this._queue = [];
    this._config = config;
  }

  _createClass(VendorPlugin, [{
    key: "beforeVideo",
    value: function beforeVideo() {}
  }, {
    key: "afterVideo",
    value: function afterVideo() {}
  }, {
    key: "dispose",
    value: function dispose() {}
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, src;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this._loaded || this._loading)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                this._loading = true;
                _context.prev = 3;

                if (!(this._src && typeof this._src === 'string')) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return this._loadScript(this._src);

              case 7:
                _context.next = 44;
                break;

              case 9:
                if (!(Array.isArray(this._src) && !this._concurrent)) {
                  _context.next = 38;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 13;
                _iterator = this._src[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 22;
                  break;
                }

                src = _step.value;
                _context.next = 19;
                return this._loadScript(src);

              case 19:
                _iteratorNormalCompletion = true;
                _context.next = 15;
                break;

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 28:
                _context.prev = 28;
                _context.prev = 29;

                if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                  _iterator["return"]();
                }

              case 31:
                _context.prev = 31;

                if (!_didIteratorError) {
                  _context.next = 34;
                  break;
                }

                throw _iteratorError;

              case 34:
                return _context.finish(31);

              case 35:
                return _context.finish(28);

              case 36:
                _context.next = 44;
                break;

              case 38:
                if (!Array.isArray(this._src)) {
                  _context.next = 43;
                  break;
                }

                _context.next = 41;
                return Promise.all(this._src.map(function (src) {
                  return _this._loadScript(src);
                }));

              case 41:
                _context.next = 44;
                break;

              case 43:
                throw new Error('Fetch vendor source is malformed');

              case 44:
                this._loading = false;
                this._loaded = true;

                this._initialize();

                _context.next = 54;
                break;

              case 49:
                _context.prev = 49;
                _context.t1 = _context["catch"](3);
                videojs.log.error("Fetch vendor ".concat(this.pluginName, " failed"), _context.t1);
                this._loading = false;
                return _context.abrupt("return", false);

              case 54:
                return _context.abrupt("return", true);

              case 55:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 49], [13, 24, 28, 36], [29,, 31, 35]]);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "_addToQueue",
    value: function _addToQueue(func) {
      var _this2 = this;

      return new Promise(function (resolve) {
        if (typeof func !== 'function') {
          throw new Error('Vendor Plugin _addToQueue first arg must be a func');
        }

        if (!_this2._autoLoad && !_this2._loading && !_this2._loaded) {
          throw new Error('Vendor Plugin load must be called before func queuing');
        }

        if (!_this2._initialized) {
          _this2._queue.push(function () {
            return resolve(func());
          });
        } else {
          resolve(func());
        }
      });
    }
  }, {
    key: "_initialize",
    value: function _initialize() {
      this._queue.forEach(function (func) {
        return func();
      });

      this._initialized = true;
    }
  }, {
    key: "_loadScript",
    value: function () {
      var _loadScript2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(src) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", new Promise(function (resolve, reject) {
                  var _script = document.createElement('script');

                  _script.type = 'text/javascript';
                  _script.src = src;
                  _script.defer = true;
                  _script.async = true;
                  _script.onreadystatechange = resolve;
                  _script.onload = resolve;
                  _script.onerror = reject;
                  document.head.appendChild(_script);
                }));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function _loadScript(_x) {
        return _loadScript2.apply(this, arguments);
      }

      return _loadScript;
    }()
  }]);

  return VendorPlugin;
}();

var PlaySwapPlugin =
/*#__PURE__*/
function (_PlayerPlugin) {
  _inherits(PlaySwapPlugin, _PlayerPlugin);

  function PlaySwapPlugin(config) {
    var _this;

    _classCallCheck(this, PlaySwapPlugin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlaySwapPlugin).call(this, config));

    _defineProperty(_assertThisInitialized(_this), "pluginName", 'playSwap');

    _defineProperty(_assertThisInitialized(_this), "handlePlaySwap", function (e) {
      var id = e.target.id;

      _this.players.forEach(function (player) {
        // Pause the other player(s)
        if (player.el().getAttribute('id') !== id) {
          player.pause(); // Pause ima3 ad player if ima3 is detected

          if (player.ima3 && player.ima3.adPlayer && player.ima3.adsManager) {
            player.ima3.adPlayer.pause();
          }
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setupPlaySwap", function (player) {
      player.on('play', _this.handlePlaySwap);
      player.on('ads-play', _this.handlePlaySwap);
    });

    _this.players = []; // global players list

    return _this;
  }

  _createClass(PlaySwapPlugin, [{
    key: "beforeVideo",
    value: function beforeVideo(player) {
      // refresh players list when a new player is initialized
      this.players = videojs.getAllPlayers();
      if (this.players.length < 2) return;
      this.setupPlaySwap(player);
    }
  }]);

  return PlaySwapPlugin;
}(PlayerPlugin);

var REFRESH_TIMEOUT = 5000;

var RefreshStreamPlugin =
/*#__PURE__*/
function (_PlayerPlugin) {
  _inherits(RefreshStreamPlugin, _PlayerPlugin);

  function RefreshStreamPlugin(config) {
    var _this;

    _classCallCheck(this, RefreshStreamPlugin);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RefreshStreamPlugin).call(this, config));

    _defineProperty(_assertThisInitialized(_this), "pluginName", 'refreshStream');

    _defineProperty(_assertThisInitialized(_this), "handlePause", function (player) {
      // Don't refresh if we're currently casting. This causes the tech to unload
      if (player.techName_ === 'Chromecast') return;
      clearTimeout(player.refreshStream.timer);
      var timer = setTimeout(function () {
        player.refreshStream.shouldRefresh = true;
      }, _this.refreshTimeout);
      player.refreshStream.timer = timer;
    });

    _defineProperty(_assertThisInitialized(_this), "handlePlay", function (player, options) {
      if (player.techName_ === 'Chromecast') return;
      clearTimeout(player.refreshStream.timer);
      if (!player.refreshStream.shouldRefresh) return;
      player.refreshStream.shouldRefresh = false;
      var video = options.video;

      if (video && video.sources && video.sources.length) {
        player.src(video.sources[0]);
      }

      player.ready(function () {
        player.play();
        player.trigger('player-refresh-stream');
      });
    });

    _this.refreshTimeout = config.REFRESH_STREAM_TIMEOUT || REFRESH_TIMEOUT;
    return _this;
  }

  _createClass(RefreshStreamPlugin, [{
    key: "afterVideo",
    value: function afterVideo(player, options) {
      var _this2 = this;

      if (options.videoType !== 'live') return;
      player.refreshStream = {
        shouldRefresh: false,
        timer: null
      };
      player.on('pause', function () {
        return _this2.handlePause(player);
      });
      player.on('play', function () {
        return _this2.handlePlay(player, options);
      });
      player.on('dispose', function () {
        return clearTimeout(player.refreshStream.timer);
      });
    }
  }]);

  return RefreshStreamPlugin;
}(PlayerPlugin);

console.log("UTILS ANAN");
var ads = {
  ADPLAY: 'adplay',
  ADTIMEUPDATE: 'adtimeupdate',
  ADS_POD_STARTED: 'ads-pod-started',
  ADS_AD_STARTED: 'ads-ad-started',
  ADS_AD_ENDED: 'ads-ad-ended',
  ADS_PAUSE: 'ads-pause',
  CONTENTPLAYBACK: 'contentplayback'
};
var media = {
  ENDED: 'ended',
  PAUSE: 'pause',
  PLAY: 'play',
  TIMEUPDATE: 'timeupdate'
};
var vjs = {
  FIRSTPLAY: 'firstplay'
  /**
   * Player events
   */

};
var player = {
  adsclick: 'player__adsclick',
  adstart: 'player__adstart',
  adend: 'player__adend',
  adbreakstart: 'player__adbreakstart',
  adbreakcomplete: 'player__adbreakcomplete',
  click: 'player__click',
  play: 'player__play',
  pause: 'player__pause',
  firstplay: 'player__firstplay',
  playing: 'player__playing',
  adsready: 'player__adsready',
  adserror: 'player__adserror',
  adspause: 'player__adspause',
  adsplay: 'player__adsplay',
  adspodstarted: 'player__adspodstarted',
  adspodended: 'player__adspodended',
  ima3hardtimeout: 'player__ima3hardtimeout',
  ima3started: 'player__ima3started',
  ima3complete: 'player__ima3complete',
  progress: 'player__progress',
  ready: 'player__ready',
  id3: 'player__id3',
  loaded: 'player__loaded',
  loadedmetadata: 'player__loadedmetadata',
  loadeddata: 'player__loadeddata',
  contentupdate: 'player__contentupdate',
  timeupdate: 'player__timeupdate',
  fullscreen: 'player__fullscreen',
  volume: 'player__volume',
  mute: 'player__mute',
  exit: 'player__exit',
  refreshstream: 'player__refreshstream',
  error: 'player__error',
  seek: 'player__seek',
  seeked: 'player__seeked',
  unmount: 'player__unmount',
  togglePlay: 'player__togglePlay',
  complete: 'player__complete',
  finished: 'player__finished',
  timerFired: 'player__timerfired',
  contentWillUpdate: 'player__contentwillupdate'
};
var yospace = {
  adstart: 'yospace__advertstart',
  adend: 'yospace__advertend',
  adbreakstart: 'yospace__adbreakstart',
  adbreakcomplete: 'yospace__adbreakend'
};
var timer = {
  fired: 'swmTimerFired'
  /**
   * Custom events triggered internally
   */

};
var custom = ['yospace-adbreakstart', 'yospace-advertstart', 'yospace-advertend', 'yospace-adbreakend', 'yospace-updatetimeline', 'yospace-id3', 'player-resize', 'player-refresh-stream', 'player-toggleplay', 'cuechange', // Ima 3 events
'ima3-hard-timeout', 'adsready', 'adplaying', 'adscanceled', 'adserror', 'nopreroll', 'nopostroll', 'contentresumed', timer.fired];
/**
 * Native events fired by BC, ima3, video.js
 */

var _native = [].concat(_toConsumableArray(Object.values(_objectSpread2({}, ads, {}, media, {}, vjs))), [// Brightcove events
'adend', 'ads-allpods-completed', 'ads-click', 'ads-first-quartile', 'ads-load', 'ads-midpoint', 'ads-play', 'ads-pod-ended', 'ads-request', 'ads-third-quartile', 'ads-volumechange', 'adstart', 'bc-catalog-error', 'ima3-ad-error', 'ima3-complete', 'ima3-ready', 'ima3-started', 'ima3-hard-timeout', 'ima3error', 'player_load', 'play_request', 'video_engagement', 'video_impression', 'video_view', // HTML5 Events
'abort', 'canplay', 'canplaythrough', 'catalog_request', 'catalog_response', 'click', 'touchend', 'contentupdate', 'durationchange', 'emptied', 'encrypted ', 'error', 'fullscreenchange', 'interruptbegin', 'interruptend', 'loadedalldata', 'loadeddata', 'loadedmetadata', 'loadedplaylist', 'loadstart', 'mediachange', 'playing', 'progress', 'ratechange', 'ready', 'resize', 'seek', 'seeked', 'seeking', 'stalled', 'suspend', 'useractive', 'userinactive', 'volumechange', 'waiting']);

var events = {
  ads: ads,
  player: player,
  yospace: yospace,
  timer: timer,
  media: media,
  "native": _native,
  custom: custom,
  vjs: vjs
};

var version = "0.9.1";

export { PlaySwapPlugin, PlayerPlugin, RefreshStreamPlugin, version as VERSION, VendorPlugin, events };
